import dayjs from "dayjs";
import { Locale } from "../../../../config/locales";

export const estimateShippingAndDeliveryDates = (
  locale: Locale,
  startingDate: Date,
  format: string = "MM/DD",
) => {
  const processedDate = dayjs(startingDate);
  const { shipBusinessDays, deliveryDays } = locale;

  const shipDate = processedDate.add(shipBusinessDays, "day");
  const deliveryDate = processedDate.add(deliveryDays, "day");

  return {
    processedDate: processedDate.format(format),
    shipDate: shipDate.format(format),
    deliveryDate: deliveryDate.format(format),
  };
};
